import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    IonButton, IonCard, IonCardTitle, IonCol, IonContent, IonGrid, IonIcon, IonInput,
    IonItem, IonLabel, IonRow, IonText
} from '@ionic/react';
import { checkmarkCircleOutline, closeCircleOutline } from 'ionicons/icons';

import { GetABMUsers } from '../../store/ABMUsers/ABMUsersActions';

import ApiRequestor from '../../api_access/ApiRequestor';

import './ABMUsers.css';
import Modal from '../Modal/Modal';

interface Data {
    username: string,
    bank_id: string,
    first_name: string,
    last_name: string,
    phone_number: string,
    email: string,
    category: string,
    notifications?: any,
}

interface Props extends StateTypes, dispatchTypes {
    userData: Data;
    backToTable: () => void
}

const ModifyABMUsers: React.FC<Props> = (props): JSX.Element => {

    const [dataUser, setDataUser] = useState({
        username: '',
        bank_id: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        category: '',
    });
    const [showModal, setShowModal] = useState(false);
    const [textModal, setTextModal] = useState('');
    const [errors, setErrors] = useState({ first_name: '', last_name: '', phone_number:'' });
    const regularExpressionPhone = /^\+549\d{10}$/;
    const nameRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+(\s[a-zA-ZáéíóúÁÉÍÓÚñÑ]+)*$/;


    useEffect(() => {
        setDataUser({
            username: props.userData.username,
            bank_id: props.userData.bank_id,
            first_name: props.userData.first_name,
            last_name: props.userData.last_name,
            phone_number: props.userData.phone_number,
            email: props.userData.email,
            category: props.userData.category
        })
    }, [])

    const getDataForm = (e: any) => {
        setDataUser({
            ...dataUser,
            [e.target.name]: e.detail.value!
        })
    }

    const validationForm = () => {

        const isEmpty = (value: any) => !value.trim();
        const isInvalidText = (value: any) => !nameRegex.test(value);

        const errors = {
            first_name: isEmpty(dataUser.first_name)
                ? 'El campo "Nombre" no debe ser vacío': 
                isInvalidText(dataUser.first_name) || dataUser.first_name.length >= 30
                ? 'Solo letras y espacios intermedios. Máximo 30 caracteres'
                : '',
            last_name: isEmpty(dataUser.last_name)
                ? 'El campo "Apellido" no debe ser vacío':
                isInvalidText(dataUser.last_name) || dataUser.last_name.length >= 30
                ? 'Solo letras y espacios intermedios. Máximo 30 caracteres'
                : '',
            phone_number: !regularExpressionPhone.test(dataUser.phone_number) || dataUser.phone_number.length >= 25
                ? 'Debe ser de la forma +549 más 10 dígitos'
                : ''
        }
        setErrors(errors as any);
        const hasErrors = Object.values(errors).some(error => error !== '');

        return hasErrors;

    }

    const modifyUser = async (e: any) => {
        e.preventDefault();
        validationForm()
        let valid = validationForm();

        if (!valid) {
            let data: any = {
                body: {
                    "username": dataUser.username,
                    "bank_id": dataUser.bank_id,
                    "first_name": dataUser.first_name,
                    "last_name": dataUser.last_name,
                    "phone_number": dataUser.phone_number,
                    "email": dataUser.email,
                    "category": dataUser.category
                }
            }

            const response: any = await ApiRequestor.requestToApi("/user", "PUT", data, "USER");
            if (response && response.status === 200) {
                setTextModal('Usuario Modificado Correctamente')
                props.getABMUsers()
                setShowModal(true);
            } else {
                if (response && response.includes("status code 500")) {
                    setTextModal('No se pudo modificar el usuario. Por favor chequear los datos ingresados')
                    setShowModal(true)
                }
            }

        } else {
            validationForm()
        }
    }

    const dismissModal = () => {
        setShowModal(false);
        if (textModal.includes('Usuario Modificado Correctamente')) {
            props.backToTable()
        }
    }

    return (
        <div className="custom-content-scroll ion-padding">
            <IonCard className="ABMUsersFormCard">
                <IonCardTitle className="ion-text-center ABMUsersFormTitle">
                    MODIFICAR USUARIO
                </IonCardTitle>
                <IonGrid className="ion-margin ion-no-margin-top">
                    <IonRow className='AMBUsersModifyTable'>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Nombre
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Ingrese el nombre"
                                    className="ion-padding ABMUsersFormInput"
                                    name="first_name"
                                    value={dataUser.first_name}
                                    onIonChange={(e) => getDataForm(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.first_name ? "login-valid-text" : "ion-hide"}>{errors.first_name}</p>
                            </IonText>
                        </IonCol>
                        <IonCol sizeLg='6' sizeXs='12' className="ABMUsersFormCol">
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Apellido
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Ingrese el apellido"
                                    className="ion-padding ABMUsersFormInput"
                                    name="last_name"
                                    value={dataUser.last_name}
                                    onIonChange={(e) => getDataForm(e)}>
                                </IonInput>
                            </IonItem>
                            <IonText>
                                <p className={errors.last_name ? "login-valid-text" : "ion-hide"}>{errors.last_name}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Username
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Ingrese el username"
                                    className="ion-padding ABMUsersFormInput"
                                    name="username"
                                    value={dataUser.username}
                                    disabled />
                            </IonItem>
                        </IonCol>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Email
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Ingrese el email"
                                    className="ion-padding ABMUsersFormInput"
                                    name="email"
                                    value={dataUser.email}
                                    onIonChange={(e) => getDataForm(e)}
                                    disabled />
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Servicio
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Seleccione el servicio"
                                    className="ion-padding ABMUsersFormInput"
                                    name="bank_id"
                                    value={dataUser.bank_id}
                                    disabled />
                            </IonItem>
                        </IonCol>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Categoría
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                            {
                                    dataUser.category === 'BANCOS' ?
                                    <IonInput
                                    type="text"
                                    placeholder="Seleccione la categoría"
                                    className="ion-padding ABMUsersFormInput"
                                    name="bank_id"
                                    value="NEWPAY"
                                    disabled />
                                    :
                                    dataUser.category === 'RETAIL' ?
                                    <IonInput
                                    type="text"
                                    placeholder="Seleccione la categoría"
                                    className="ion-padding ABMUsersFormInput"
                                    name="bank_id"
                                    value="PAYWAY"
                                    disabled />
                                    :
                                    dataUser.category === 'INTERNO' ?
                                    <IonInput
                                    type="text"
                                    placeholder="Seleccione la categoría"
                                    className="ion-padding ABMUsersFormInput"
                                    name="bank_id"
                                    value="PRISMA"
                                    disabled />
                                    :
                                    <IonInput
                                    type="text"
                                    placeholder="Seleccione la categoría"
                                    className="ion-padding ABMUsersFormInput"
                                    name="bank_id"
                                    value={dataUser.category}
                                    disabled />
                                }
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Número de Teléfono
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Ingrese el número de teléfono"
                                    className="ion-padding ABMUsersFormInput"
                                    name="phone_number"
                                    value={dataUser.phone_number}
                                    onIonChange={(e) => getDataForm(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.phone_number ? "login-valid-text" : "ion-hide"}>{errors.phone_number}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow className="ABMUsers-container-button ion-margin-horizontal ion-margin-top ion-no-margin-bottom ion-justify-content-center">
                        <IonButton type="submit" fill="clear" onClick={modifyUser}>
                            <IonIcon icon={checkmarkCircleOutline} color="success" className="ion-padding ion-no-padding-bottom AMBUsersButton" />
                        </IonButton>
                        <IonButton fill="clear" onClick={props.backToTable}>
                            <IonIcon icon={closeCircleOutline} color="danger" className="ion-padding ion-no-padding-bottom AMBUsersButton" />
                        </IonButton>
                    </IonRow>
                </IonGrid>
            </IonCard>

            <Modal
                modalConfirmation={{
                    textConfirmation: textModal,
                    onDidDimissConfirmModal: dismissModal,
                    isOpenModalConfirm: showModal,
                    onClickConfirmModal: dismissModal,
                }}
            />

        </div>
    );
}

interface StateTypes {
}

const mapStateProps = (state: StateTypes) => {
    return {}
}

interface dispatchTypes {
    getABMUsers: () => void;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getABMUsers: () => dispatch(GetABMUsers())
    };
}

export default connect(mapStateProps, mapDispatchToProps)(ModifyABMUsers);